import { Component, OnInit } from "@angular/core";
import { ParametrosService } from "./services/parametros.service";
import { ActivatedRoute } from "@angular/router";
import { ServerUrlService } from "./services/server-url.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "agenda-app";

  layout: string;
  onLoad: boolean;

  constructor(
    private parametros: ParametrosService,
    private ar: ActivatedRoute,
    private serverUrl: ServerUrlService
  ) {}

  ngOnInit() {
    // const client = this.ar.snapshot.paramMap.get('client')
    let client = location.pathname.split("/")[1];
    const newClient = this.serverUrl.clients.find((val) => val.name === client);

    this.serverUrl.name = client;
    if (!newClient) {
      fetch(`https://cms-backend.otimusclinic.com/variables/host/${client}`, {
        method: "POST",
      })
        .then((val) => val.json())
        .then((val) => {
          this.serverUrl.url = val.find(
            (el: any) => el.chave === `Agendamento_Web_URL`
          ).valor;

          const otimusUrl = val.find((el: any) => el.chave === `Otimus_URL`);
          this.serverUrl.otimusUrl = otimusUrl && otimusUrl.valor;

          this.loadTheme();
        });
      return;
    } else {
      this.serverUrl.url = newClient.url;
      this.serverUrl.otimusUrl = "http://localhost:2022";
      this.loadTheme();
    }
  }

  private loadTheme() {
    this.onLoad = false;
    this.parametros.onLoadParams().subscribe((data) => {
      const myParam: any = data;
      const theme = myParam.find((fnd) => fnd.chave === "APP_THEME") || {
        valor: "",
      };
      this.parametros.setParams(data);
      this.layout = "main-div " + theme.valor;
      this.onLoad = false;
    });
  }
}
